/***
 *
 *   TICKETS PAGE STYLES
 *   Reference page frame: ContentContainer-shaped column with toolbar + board.
 *   Phase 3 moved scroll onto `main` and dropped the old h-full wrapper, so
 *   this flex chain is what gives the board a full-height container again.
 *
 **********/

const Style = {
    page: 'flex min-h-0 flex-1 flex-col gap-6',
    stack: 'flex min-h-0 flex-1 flex-col gap-3',
    boardWrap: 'flex min-h-0 flex-1 flex-col',
    board: 'scrollbar-kanban flex h-full min-h-0 gap-4 overflow-auto pb-4 snap-x snap-mandatory md:snap-none',
    boardLoading: 'scrollbar-kanban flex gap-4 overflow-x-auto pb-4',
};

export default Style;
